<script>

export default {
  name: 'CountBox',

  props: {
    name: {
      type:     String,
      required: true
    },
    count: {
      type:     Number,
      required: true
    },
    primaryColorVar: {
      type:     String,
      required: true
    },
    compact: {
      type:    Boolean,
      default: false
    }
  },
  computed: {
    accentStyle() {
      return { '--count-accent': `rgba(var(${ this.primaryColorVar }), 1)` };
    }
  }

};
</script>

<template>
  <div
    class="count-container"
    :class="{ compact, 'is-empty': count === 0 }"
    :style="accentStyle"
    role="group"
    :aria-label="`${ name }: ${ count }`"
  >
    <span class="count-value">{{ count }}</span>
    <span class="count-label">
      <span
        class="count-dot"
        aria-hidden="true"
      />
      {{ name }}
    </span>
  </div>
</template>

<style lang="scss" scoped>
.count-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 8px;
  min-width: 0;
  height: 100%;
  padding: 16px;
  border: 1px solid var(--border);
  border-radius: 10px;
  background: var(--simple-box-bg, var(--body-bg));
  color: var(--body-text);
}
.count-value {
  font-size: 30px;
  font-weight: 600;
  line-height: 1.15;
  font-variant-numeric: tabular-nums;
  letter-spacing: -0.025em;
}
.count-label {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  font-size: 13px;
  line-height: 1.4;
  color: var(--muted);
  overflow-wrap: anywhere;
}
.count-dot {
  flex: 0 0 7px;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--count-accent, var(--muted));
}
.compact {
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;

  .count-value {
    font-size: 26px;
  }
}
.is-empty .count-value {
  color: var(--muted);
}
@media (max-width: 480px) {
  .count-container {
    padding: 12px;
  }
  .compact {
    gap: 8px;
  }
}
</style>
